/**
 * @generated SignedSource<<bd0025f66c75b510f774a72c600d3632>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type UpdateProgramFinancialMetadataInput = {
  id?: string | null;
  budgetType?: PROGRAM_BUDGET_TYPE | null;
  budgetValue?: number | null;
  revenueSetting?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateProgramFinancialMetadataMutation$variables = {
  input: UpdateProgramFinancialMetadataInput;
};
export type updateProgramFinancialMetadataMutation$data = {
  readonly updateProgramFinancialMetadata: {
    readonly program: {
      readonly node: {
        readonly id: string;
        readonly budgetType: PROGRAM_BUDGET_TYPE | null;
        readonly budgetValue: number | null;
        readonly revenueSetting: string | null;
      } | null;
    } | null;
  } | null;
};
export type updateProgramFinancialMetadataMutation = {
  variables: updateProgramFinancialMetadataMutation$variables;
  response: updateProgramFinancialMetadataMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProgramFinancialMetadataPayload",
    "kind": "LinkedField",
    "name": "updateProgramFinancialMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProgramTypeEdge",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueSetting",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProgramFinancialMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProgramFinancialMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e509583887abf321cc912e940a60c76",
    "id": null,
    "metadata": {},
    "name": "updateProgramFinancialMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation updateProgramFinancialMetadataMutation(\n  $input: UpdateProgramFinancialMetadataInput!\n) {\n  updateProgramFinancialMetadata(input: $input) {\n    program {\n      node {\n        id\n        budgetType\n        budgetValue\n        revenueSetting\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "470d27574cbc8a016e51a33d9607b725";

export default node;
